module.exports = __webpack_public_path__ + "img/tanker_active.fbe0d3f1.svg";